import { useState, useEffect, useRef } from 'react'

export const useDebounce = (value, delay) => {
  const [debouncedValue, setDebouncedValue] = useState(value)

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value)
    }, delay)

    return () => {
      clearTimeout(handler)
    }
  }, [delay, value])

  return debouncedValue
}

export function usePortal(id) {
  const rootElemRef = useRef(document.createElement('div'))

  useEffect(
    function setupElement() {
      const element = rootElemRef.current
      const parentElem = document.getElementById(id)
      parentElem.prepend(element)
      return function removeElement() {
        element.remove()
      }
    },
    [id]
  )

  return rootElemRef.current
}
